export default "__VITE_ASSET__BbHrbJ6L__"